import React, { useEffect, useState } from "react";
import {
  Button,
  Col,
  Form,
  Image,
  Input,
  message,
  Radio,
  Row,
  Typography,
} from "../../components/common/utils/antd-imports/AntdImports";
import FloatingInput from "../../components/common/float-input/FloatInput";
import SignupImg from "../../assests/signup-landing-image.png";
import AMPlogo_w from "../../assests/ampw-svg.svg";
import Amplogo from "../../assests/amp_logo.svg";
import "./SignupPage.css";
import { useMediaQuery } from "react-responsive";
import { useDispatch, useSelector } from "react-redux";
import { signup } from "../../store/thunks/authThunk";
import { useLocation, useNavigate } from "react-router-dom";
import FloatingSelect from "../../components/common/floating-select/floatingSelect";
import {
  activateUserAccount,
  userResendOtp,
} from "../../store/thunks/authThunk";
import {
  loadCaptchaEnginge,
  validateCaptcha,
  LoadCanvasTemplateNoReload,
} from "react-simple-captcha";
import { SyncOutlined } from "@ant-design/icons";
import {
  allowAlphabetsWithInnerSpace,
  blockPasteInvalid,
} from "../../components/common/utils/Utils";
const { Text } = Typography;

const SignupPage = () => {
  const location = useLocation();
  const isSmL = useMediaQuery({ minWidth: 769, maxWidth: 2560 });
  const isSmL1 = useMediaQuery({ minWidth: 0, maxWidth: 768 });
  const star = <span style={{ color: "#d2042d" }}>*</span>;
  const [verifyState, setVerifyState] = useState(false);
  const [resendState, setResendState] = useState(false);
  const [userEmail, setUserEmail] = useState("");
  const [form] = Form.useForm();
  const [role, setRole] = useState("buyer");
  const [timeLeft, setTimeLeft] = useState("");
  const [userData, setUserData] = useState("");
  const dispatch = useDispatch();
  const { isLoading, signupStatus, status } = useSelector(
    (state) => state.signup,
  );
  const [otpValue, setOtpValue] = useState("");
  const navigate = useNavigate();
  const [expired, setExpired] = useState(false);
  const formValues = Form.useWatch([], form);
  const [isCaptchaValid, setIsCaptchaValid] = useState(false);
  const floatingInputStyles = {
    marginTop: "0px",
    "--input-font-weight": "500",
    "--label-focused-top": "23px",
    "--label-focused-z-index": 1,
    "--label-focused-color": "#333",
    "--label-padding-left": "0.5rem",
    "--label-margin-top": "-6px",
  };
  const floatingSelectStyles = {
    marginTop: "0px",
    "--input-font-weight": "500",
    "--label-focused-top": "23px",
    "--label-focused-z-index": 1,
    "--label-focused-color": "#333",
    "--label-padding-left": "0.6rem",
    "--input-padding-top": "1rem",
  };

  useEffect(() => {
    if (signupStatus === "success" && status === 1 && role == "seller") {
      // form.resetFields();
      navigate("/login");
    }
  }, [form, navigate, signupStatus, status, role]);

  useEffect(() => {
    if (location.state?.selectedUser) {
      setRole(location.state.selectedUser);
    }
  }, [location.state]);

  useEffect(() => {
    try {
      if (!verifyState) {
        const t = setTimeout(() => loadCaptchaEnginge(6), 0);
        return () => clearTimeout(t);
      }
    } catch (err) {
      message.error("Something went wrong!");
    }
  }, [verifyState]);
  useEffect(() => {
    if (!verifyState) {
      try {
        loadCaptchaEnginge(6);
      } catch (error) {
        message.error("Something went wrong!");
      }
    }
  }, [role, verifyState]);

  useEffect(() => {
    if (window.location.hash === "#verify") {
      setVerifyState(true);
    }
    const savedEmail = localStorage.getItem("userEmail");
    if (savedEmail) {
      setUserEmail(savedEmail);
    }
    const handleBack = () => {
      setVerifyState(false);
    };
    window.addEventListener("popstate", handleBack);
    return () => {
      window.removeEventListener("popstate", handleBack);
    };
  }, []);

  useEffect(() => {
    if (!verifyState) return;
    const expiryStr = localStorage.getItem("userData");
    if (!expiryStr) return;
    const expiryDate = new Date(expiryStr + " UTC");
    const timer = setInterval(() => {
      const now = new Date();
      const diff = expiryDate - now;
      if (diff <= 0) {
        setExpired(true);
        setTimeLeft("00:00");
        clearInterval(timer);
      } else {
        const minutes = Math.floor(diff / 1000 / 60);
        const seconds = Math.floor((diff / 1000) % 60);
        setTimeLeft(
          `${minutes?.toString()?.padStart(2, "0")}:${seconds?.toString()?.padStart(2, "0")}`,
        );
        setExpired(false);
      }
    }, 1000);

    return () => clearInterval(timer);
  }, [verifyState, userData]);

  const checkCaptcha = (value) => {
    const isValid = validateCaptcha(value);
    if (!isValid) {
      return false;
    }
    return true;
  };
  const verifyAndContinue = () => {
    const payload = {
      email: userEmail,
      otp: otpValue,
    };
    if (!otpValue || otpValue.length < 6) {
      message.error("Please provide a valid 6-digit OTP.");
      return;
    }
    setResendState(false);
    dispatch(activateUserAccount(payload)).then((res) => {
      if (res?.payload?.status === 1) {
        navigate("/login");
        localStorage.removeItem("userEmail");
      }
    });
  };

  const resendOtp = () => {
    setResendState(true);
    const payload = {
      email: userEmail,
    };
    dispatch(userResendOtp(payload)).then((res) => {
      if (res?.payload?.status === 1) {
        localStorage.setItem(
          "userData",
          res?.payload?.user_details?.otp_signup_time,
        );
        setUserData(localStorage.getItem("userData"));
        setExpired(false);
      }
    });
  };
  const handleSubmit = (values) => {
    setUserEmail(values.email);
    localStorage.setItem("userEmail", values.email);
    const utmSource = localStorage.getItem("utm_source");
    const { captcha, confirm_password, ...restValues } = values;
    const payload = {
      ...restValues,
      role,
      ...(utmSource && { utm_source: utmSource }),
    };

    if (role === "buyer") {
      if (checkCaptcha(values.captcha)) {
        dispatch(signup(payload)).then((res) => {
          if (res?.payload?.status === 1) {
            window.location.hash = "#verify";
            setVerifyState(true);
            localStorage.setItem(
              "userData",
              res?.payload?.user_details?.otp_signup_time,
            );
          }
        });
      }
    } else {
      dispatch(signup(payload));
    }
  };
  const isSignupDisabled = () => {
    const hasErrors = form.getFieldsError().some(({ errors }) => errors.length);

    const requiredFields = [
      "name",
      "last_name",
      "phone",
      "email",
      "password",
      "confirm_password",
      "account_type",
      role === "buyer" ? "company_name" : "companyName",
      "captcha",
    ];

    const hasEmptyFields = requiredFields.some((field) => {
      const value = form.getFieldValue(field);

      return (
        value === undefined ||
        value === null ||
        value === "" ||
        (Array.isArray(value) && value.length === 0)
      );
    });

    return hasErrors || hasEmptyFields || !isCaptchaValid;
  };

  return (
    <div>
      <Row style={{ height: "96vh" }}>
        {isSmL && (
          <Col span={12}>
            <div
              className="login-image"
              style={{
                backgroundImage: `url(${SignupImg})`,
                height: "100%",
                width: "100%",
              }}
            >
              <div className="gradient-layer" />
              <Image
                src={AMPlogo_w}
                alt="logo"
                className="logo-overlay"
                preview={false}
                onClick={() => navigate("/")}
              />
            </div>
          </Col>
        )}

        <Col className="sigup-form-container">
          <div className="signup-container">
            {isSmL1 ? (
              <div>
                <Image
                  src={Amplogo}
                  alt="amp-logo"
                  height={50}
                  width={190}
                  onClick={() => navigate("/")}
                />
              </div>
            ) : (
              <></>
            )}

            {/* <Space direction="vertical"> */}
            <Row justify="center">
              <Text className="signup-h">
                {verifyState
                  ? "Verify Your Account"
                  : "Join the Advertising Marketplace"}
              </Text>
            </Row>
            <Row justify="center" style={{ textAlign: "center" }}>
              {verifyState ? (
                <Text className="signup-sh" style={{ width: "65%" }}>
                  We’ve sent a 6-digit code to {userEmail}. Please enter it
                  below to activate your account{" "}
                  {expired ? (
                    <spann className="otp-expired">(OTP Expired).</spann>
                  ) : (
                    <spann className="otp-expired">
                      (Expires at {timeLeft}).
                    </spann>
                  )}
                </Text>
              ) : (
                <Text className="signup-sh">
                  Choose your role and unlock the potential of targeted
                  advertising.
                </Text>
              )}
            </Row>
            {verifyState ? (
              <>
                <Row
                  style={{ marginTop: "20px" }}
                  justify="center"
                  className="opt-verification-input-container"
                >
                  <Input.OTP
                    value={otpValue}
                    onInput={(val) => {
                      const raw = Array.isArray(val) ? val.join("") : val;
                      const numericValue = (raw || "")
                        .replace(/[^0-9]/g, "")
                        .slice(0, 6);
                      setOtpValue(numericValue);
                    }}
                    onKeyPress={(e) => {
                      if (!/[0-9]/.test(e.key)) {
                        e.preventDefault();
                      }
                    }}
                    size="large"
                    className="opt-verification-input"
                  />
                </Row>
                <Text
                  className="signup-sh"
                  style={{ marginBottom: "10px", marginTop: "0px" }}
                >
                  Didn’t receive the code?
                  <span
                    className={`resend-text ${
                      !expired ? "disabled-opacity" : ""
                    }`}
                    onClick={resendOtp}
                  >
                    {" "}
                    Resend
                  </span>
                </Text>
                <Row justify="center" style={{ width: isSmL1 ? "60%" : "40%" }}>
                  <Button
                    type="primary"
                    id="register_seller_otp_verify_btn"
                    className={`signup-button billboard-button-2 ${
                      verifyState && (otpValue || "").length < 6
                        ? "disabled-opacity"
                        : ""
                    }`}
                    loading={isLoading}
                    onClick={verifyAndContinue}
                  >
                    {isLoading
                      ? resendState
                        ? "Resending..."
                        : "Verifying..."
                      : "Verify & Continue"}
                  </Button>
                </Row>
              </>
            ) : (
              <>
                <Form
                  form={form}
                  className="signup-form"
                  onFinish={handleSubmit}
                >
                  <Row
                    justify="start"
                    className="radio-grp-btn"
                    style={{ height: 35 }}
                  >
                    <Col>
                      <Radio.Group
                        defaultValue={
                          location.state?.selectedUser
                            ? location.state?.selectedUser
                            : role
                        }
                        onChange={(e) => {
                          setRole(e.target.value);
                          form.resetFields();
                        }}
                      >
                        <Radio value="buyer" className="radio-text">
                          Buyer
                        </Radio>
                        <Radio value="seller" className="radio-text">
                          Seller
                        </Radio>
                      </Radio.Group>
                    </Col>
                  </Row>
                  {isSmL ? (
                    <>
                      <Row className="form-fields form-fields-css">
                        <Col style={{ width: "48%" }}>
                          <Form.Item
                            name="name"
                            rules={[
                              {
                                required: true,
                                message: "First Name is required!",
                              },
                            ]}
                          >
                            <FloatingInput
                              className="billboard-input-feild"
                              label={
                                <>
                                  {`First Name `}
                                  {star}
                                </>
                              }
                              customStyles={floatingInputStyles}
                              onKeyDown={(e) => {
                                if (e.key === "Enter") {
                                  form.submit();
                                }
                              }}
                              onChange={allowAlphabetsWithInnerSpace}
                              onPaste={blockPasteInvalid}
                            />
                          </Form.Item>
                        </Col>
                        <Col style={{ width: "48%" }}>
                          <Form.Item
                            name="last_name"
                            rules={[
                              {
                                required: true,
                                message: "Last Name is required!",
                              },
                            ]}
                          >
                            <FloatingInput
                              className="billboard-input-feild"
                              label={
                                <>
                                  {`Last Name `}
                                  {star}
                                </>
                              }
                              customStyles={floatingInputStyles}
                              onKeyDown={(e) => {
                                if (e.key === "Enter") {
                                  form.submit();
                                }
                              }}
                              onChange={allowAlphabetsWithInnerSpace}
                              onPaste={blockPasteInvalid}
                            />
                          </Form.Item>
                        </Col>
                      </Row>
                    </>
                  ) : (
                    <>
                      <Row className="form-fields form-fields-css">
                        <Col style={{ width: "100%" }}>
                          <Form.Item
                            name="name"
                            rules={[
                              {
                                required: true,
                                message: "First Name is required!",
                              },
                            ]}
                          >
                            <FloatingInput
                              className="billboard-input-feild"
                              label={
                                <>
                                  {`First Name `}
                                  {star}
                                </>
                              }
                              onKeyDown={(e) => {
                                if (e.key === "Enter") {
                                  form.submit();
                                }
                              }}
                              onChange={allowAlphabetsWithInnerSpace}
                              onPaste={blockPasteInvalid}
                              customStyles={floatingInputStyles}
                            />
                          </Form.Item>
                        </Col>
                        <Col style={{ width: "100%" }}>
                          <Form.Item
                            name="last_name"
                            rules={[
                              {
                                required: true,
                                message: "Last Name is required!",
                              },
                            ]}
                          >
                            <FloatingInput
                              className="billboard-input-feild"
                              label={
                                <>
                                  {`Last Name `}
                                  {star}
                                </>
                              }
                              onKeyDown={(e) => {
                                if (e.key === "Enter") {
                                  form.submit();
                                }
                              }}
                              onChange={allowAlphabetsWithInnerSpace}
                              onPaste={blockPasteInvalid}
                              customStyles={floatingInputStyles}
                            />
                          </Form.Item>
                        </Col>
                      </Row>
                    </>
                  )}

                  <Row justify="center" className="form-row">
                    <Col style={{ width: "100%" }}>
                      <Form.Item
                        name="phone"
                        rules={[
                          { required: true, message: "Mobile is required!" },
                          {
                            pattern: /^\d{10}$/,
                            message: "Mobile number must be 10 digits!",
                          },
                        ]}
                      >
                        <FloatingInput
                          className="billboard-input-feild"
                          label={
                            <>
                              {`Mobile `}
                              {star}
                            </>
                          }
                          maxLength={10}
                          onKeyPress={(e) => {
                            if (!/^\d$/.test(e.key)) {
                              e.preventDefault();
                            }
                          }}
                          customStyles={floatingInputStyles}
                          onKeyDown={(e) => {
                            if (e.key === "Enter") {
                              form.submit();
                            }
                          }}
                        />
                      </Form.Item>
                    </Col>
                  </Row>
                  <Row justify="center" className="form-row">
                    <Col style={{ width: "100%" }}>
                      <Form.Item
                        name="email"
                        rules={[
                          { required: true, message: "Email is required!" },
                          {
                            type: "email",
                            message: "Please enter a valid email address!",
                          },
                        ]}
                      >
                        <FloatingInput
                          type="email"
                          className="billboard-input-feild"
                          label={
                            <>
                              {`Email `}
                              {star}
                            </>
                          }
                          customStyles={floatingInputStyles}
                          onKeyDown={(e) => {
                            if (e.key === "Enter") {
                              form.submit();
                            }
                          }}
                        />
                      </Form.Item>
                    </Col>
                  </Row>
                  <Row justify="center" className="form-row">
                    <Col style={{ width: "100%" }}>
                      <Form.Item
                        name="password"
                        rules={[
                          {
                            required: true,
                            message: "Password is required!",
                          },
                          {
                            pattern:
                              /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[@$!%*?&#])[A-Za-z\d@$!%*?&#]{8,}$/,
                            message: (
                              <div>
                                Please Enter at least 8 characters (it should
                                contain at least one character,
                                <br />
                                one number and one special character)
                              </div>
                            ),
                          },
                        ]}
                      >
                        <FloatingInput
                          isPassword={true}
                          className="billboard-input-feild"
                          label={
                            <>
                              {`Password `}
                              {star}
                            </>
                          }
                          customStyles={floatingInputStyles}
                          onKeyDown={(e) => {
                            if (e.key === "Enter") {
                              form.submit();
                            }
                          }}
                        />
                      </Form.Item>
                    </Col>
                  </Row>
                  <Row justify="center" className="form-row">
                    <Col style={{ width: "100%" }}>
                      <Form.Item
                        name="confirm_password"
                        rules={[
                          {
                            required: true,
                            message: "Please confirm your Password!",
                          },
                          ({ getFieldValue }) => ({
                            validator(_, value) {
                              if (
                                !value ||
                                getFieldValue("password") === value
                              ) {
                                return Promise.resolve();
                              }
                              return Promise.reject(
                                new Error("Passwords do not match!"),
                              );
                            },
                          }),
                        ]}
                      >
                        <FloatingInput
                          isPassword={true}
                          className="billboard-input-feild"
                          label={
                            <>
                              {`Confirm Password `}
                              {star}
                            </>
                          }
                          customStyles={floatingInputStyles}
                          onKeyDown={(e) => {
                            if (e.key === "Enter") {
                              form.submit();
                            }
                          }}
                        />
                      </Form.Item>
                    </Col>
                  </Row>
                  <Row justify="center" className="form-row">
                    <Col style={{ width: "100%" }}>
                      <Form.Item
                        name="account_type"
                        rules={[
                          {
                            required: true,
                            message: "Account Type is required!",
                          },
                        ]}
                      >
                        <FloatingSelect
                          className="billboard-select-feild"
                          label={
                            <>
                              {`Account Type `}
                              {star}
                            </>
                          }
                          options={[
                            {
                              id: "Business Account",
                              name: "Business Account",
                            },
                            {
                              id: "Individual Account",
                              name: "Individual Account",
                            },
                          ]}
                          customStyles={floatingSelectStyles}
                          onKeyDown={(e) => {
                            if (e.key === "Enter") {
                              form.submit();
                            }
                          }}
                        />
                      </Form.Item>
                    </Col>
                  </Row>

                  <Row justify="center">
                    <Col style={{ width: "100%" }}>
                      <Form.Item
                        name={role === "buyer" ? "company_name" : "companyName"}
                        rules={[
                          {
                            required: true,
                            message: "Company Name is required!",
                          },
                        ]}
                      >
                        <FloatingInput
                          className="billboard-input-feild"
                          label={
                            <>
                              {`Company Name `}
                              {star}
                            </>
                          }
                          customStyles={floatingInputStyles}
                          onKeyDown={(e) => {
                            if (e.key === "Enter") {
                              form.submit();
                            }
                          }}
                        />
                      </Form.Item>
                    </Col>
                  </Row>
                  {role === "seller" && (
                    <Row justify="center">
                      <Col style={{ width: "100%" }}>
                        <Form.Item name="contact_name">
                          <FloatingInput
                            className="billboard-input-feild"
                            label={
                              <>
                                {`Company DBA `}
                                {star}
                              </>
                            }
                            customStyles={floatingInputStyles}
                            onKeyDown={(e) => {
                              if (e.key === "Enter") {
                                form.submit();
                              }
                            }}
                          />
                        </Form.Item>
                      </Col>
                    </Row>
                  )}
                  <Row
                    style={{
                      display: "flex",
                      justifyContent: "space-between",
                      alignItems: "flex-start",
                    }}
                  >
                    <Col style={{ display: "flex", alignItems: "flex-start" }}>
                      <LoadCanvasTemplateNoReload
                        reloadText=""
                        className="my-captcha"
                      />
                      <SyncOutlined
                        onClick={() => {
                          loadCaptchaEnginge(6);
                          form.setFieldsValue({ captcha: "" });
                        }}
                      />
                    </Col>

                    <Col>
                      <Form.Item
                        name="captcha"
                        validateTrigger="onSubmit"
                        rules={[
                          {
                            required: true,
                            message: "Captcha is required!",
                          },
                          {
                            validator: (_, value) => {
                              if (!value) return Promise.resolve();
                              if (!checkCaptcha(value)) {
                                return Promise.reject(
                                  new Error("Captcha does not match!"),
                                );
                              }
                              return Promise.resolve();
                            },
                          },
                        ]}
                      >
                        <FloatingInput
                          className="billboard-input-feild"
                          label={
                            <>
                              {`Enter Captcha `}
                              {star}
                            </>
                          }
                          maxLength={6}
                          customStyles={floatingInputStyles}
                          onChange={(e) => {
                            const value = e.target.value;
                            setIsCaptchaValid(false);
                            if (value.length === 6) {
                              const valid = validateCaptcha(value);
                              setIsCaptchaValid(valid);
                            } else {
                              form.setFields([{ name: "captcha", errors: [] }]);
                            }
                          }}
                          onKeyDown={(e) => {
                            if (e.key === "Enter") {
                              form.submit();
                            }
                          }}
                        />
                      </Form.Item>
                    </Col>
                  </Row>
                  <Row justify="center">
                    <Button
                      type="primary"
                      htmlType="submit"
                      classNa
                      className={`signup-button billboard-button-2 ${
                        isSignupDisabled() ? "disabled-opacity" : ""
                      }`}
                      loading={isLoading}
                      disabled={isSignupDisabled()}
                      id="register_signup_btn"
                    >
                      {isLoading ? "Signing Up..." : "Sign Up"}
                    </Button>
                  </Row>
                </Form>
              </>
            )}
            {verifyState ? (
              <Row justify="center" style={{ marginTop: "1rem" }}>
                <div className="change-mail-text">
                  <Text
                    onClick={() => {
                      window.location.hash = "";
                      setOtpValue("");
                      setVerifyState(false);
                      setUserEmail("");
                      setExpired(false);
                      form.resetFields();
                    }}
                  >
                    {" "}
                    Change Email
                  </Text>{" "}
                </div>
              </Row>
            ) : (
              <Row justify="center">
                <div className="signup-text" style={{ marginTop: "40px" }}>
                  Already have an account? <a href="/login"> Sign In here</a>{" "}
                  and get started!
                </div>
              </Row>
            )}
          </div>
        </Col>
      </Row>
    </div>
  );
};

export default SignupPage;
